import React, { Fragment, useEffect, useState } from "react";
import { oneOfType, array, string, bool, shape, arrayOf } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { Link, useParams, useLocation } from "react-router-dom";

import { actions as loansActions, selectors as loansSelectors } from "reducers/loans";
import { actions as settingsActions } from "reducers/settings";
import Credential from "pages/_components/fields/credentials/Credential";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import { Row, Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import ProductSelector from "pages/_components/fields/formik/FormikProductSelector";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import Check from "pages/_components/fields/Checkbox";
import { actions, selectors } from "reducers/softToken";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import { isIOS } from "react-device-detect";
import { sumAllTypeValues, sumAllValues } from "../../../util/number";

const CancelacionAnticipada = ({
    fetching,
    fetchingCancelation,
    loansList,
    isDesktop,
    detallePrestamo,
    accounts,
    deviceStatus,
    tokenInfo,
    cancelacionPreview,
}) => {
    const dispatch = useDispatch();
    const params = useParams();
    const { id } = useParams();
    const { state = {} } = useLocation();
    const { idTransaction = "" } = state;
    const [availableAccounts, setAvailableAccounts] = useState([{ id: "1" }]);
    const [, setSelectedAccountId] = useState(null);
    const [cancelButton, setcancelButton] = useState(!!idTransaction);
    const requiredString = i18n.get("deposits.request.required");
    const FORM_ID = "unsecuredLoanForm.confirm";
    const [checkboxState, setCheckboxState] = useState(false);
    const [checkboxError, setCheckboxError] = useState(false);

    useEffect(() => {
        dispatch(settingsActions.getUserData());
        dispatch(accountsActions.listAccounts());
        dispatch(actions.getTokenInfo());
        dispatch(loansActions.getLoanDetail(id, ""));
    }, []);

    useEffect(() => {
        const prestamoActual = loansList.find((x) => x.number === id);
        dispatch(
            loansActions.gerCancelacionAnticipadaPreview(prestamoActual?.idProduct, prestamoActual?.extraInfo, id),
        );
    }, []);

    useEffect(() => {
        const formatOption = (account) => ({
            balance: { currency: account?.currency, quantity: account?.availableBalance },
            currency: account?.currency,
            frequentDestination: null,
            id: account?.productId,
            label: `${i18n.get(`productType.${account?.accountType}`)} ····${account?.accountNumber?.slice(
                -4,
            )} ${i18n.get(`currency.label.${account?.currency}`)}`,
            minimumPayment: 0,
            permissions: Object.keys(account?.permissions),
            statementsLoan: null,
            totalPayment: 0,
            type: account?.accountType,
            selectedAccountLabel: `····${account?.accountNumber?.slice(-4)} ${account?.accountType} ${i18n.get(
                `currency.label.${account?.currency}`,
            )}`,
        });

        if (accounts?.length) {
            setAvailableAccounts(accounts.filter((acc) => acc.currency === "ARS")?.map((acc) => formatOption(acc)));
        }
    }, [accounts]);
    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            debitAccount: "",
            credential: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                debitAccount: idTransaction ? Yup.string() : Yup.string().required(requiredString),
                credential: Yup.string(),
            }),
        onSubmit: (values) => {
            const token = deviceStatus === "NO_DEVICE" ? values.credential : tokenInfo.token;
            const prestamoActual = loansList.find((x) => x.number === id);
            dispatch(
                loansActions.setCancelacionAnticipadaPayOff(
                    prestamoActual.idProduct,
                    prestamoActual.extraInfo,
                    token,
                    values.debitAccount,
                    detallePrestamo,
                    idTransaction,
                ),
            );
        },
    };
    const handleCheckboxChange = () => {
        setCheckboxError(false);
        setCheckboxState(!checkboxState);
    };
    const cuentaAcreditacion = () => (
        <>
            <Formik {...formikProps}>
                {() => (
                    <Form>
                        {!idTransaction && (
                            <Row className="form-background">
                                <div
                                    className="grid-table-row md:col-start-2 md:col-span-10"
                                    style={{ width: isDesktop ? "90%" : "100%" }}>
                                    <Field
                                        idForm={FORM_ID}
                                        name="debitAccount"
                                        component={ProductSelector}
                                        label={`${i18n.get("", "Cuenta de acreditación y débito")}*`}
                                        placeholder={i18n.get("deposits.request.filters.debitAccount.placeHolder")}
                                        data={{
                                            options: availableAccounts,
                                        }}
                                        onChange={setSelectedAccountId}
                                    />
                                </div>
                            </Row>
                        )}
                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={2} lg={12} lgOffset={3}>
                                <div className="d-flex align-items-center">
                                    <div style={isIOS ? { width: "var(--space-9)" } : null}>
                                        <Check
                                            hideLabel
                                            name="termsAndConditios"
                                            onChange={handleCheckboxChange}
                                            checked={checkboxState}
                                            error={checkboxError ? "Campo requerido" : ""}
                                        />
                                    </div>
                                    <div className="d-flex pb-4">
                                        <span>Aceptá los </span>
                                        <Link to="/termsAndConditions">{i18n.get("global.termAndConditions")}</Link>
                                    </div>
                                </div>
                            </Col>
                            {deviceStatus !== "NO_DEVICE" ? null : (
                                <Col xs={12} md={4} mdOffset={2} lg={3} lgOffset={3}>
                                    <Field
                                        component={Credential}
                                        idForm="form.credential"
                                        name="credential"
                                        type="otp"
                                        labelText="form.credential.token.label"
                                        placeholderText="Ej: 120573"
                                    />
                                </Col>
                            )}
                            <Col xs={12} md={4} mdOffset={6} lg={3} lgOffset={6} className="align-items-end">
                                <div className="form-group hidden-label">
                                    <div className="button-group">
                                        <Button
                                            block
                                            type="submit"
                                            label="global.send"
                                            bsStyle="primary"
                                            loading={fetchingCancelation}
                                            disabled={!checkboxState}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </>
    );
    const renderViewMore = () => {
        if (!detallePrestamo) {
            return null;
        }

        const CancelButtonStyles = {
            backgroundColor: "#FFE082",
            borderRadius: "10px",
            padding: "15px",
        };
        return (
            <>
                <GridTable className="deposit-details-list details">
                    <GridTable.Container columns={isDesktop ? 3 : 1} rows={isDesktop ? 2 : 10}>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.loanNumber"
                                titleTextType="I18N"
                                valueText={params.id}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 3}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.currency"
                                titleTextType="I18N"
                                valueText={detallePrestamo?.currency}
                                valueTextType="TEXT"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 5}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.effectiveMonthlyRate"
                                titleTextType="I18N"
                                valueText={detallePrestamo?.rates?.find((x) => x.code === "rate_value_tem")?.value ?? 0}
                                valueTextType="PERCENTAGE"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 2}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.originalCapital"
                                titleTextType="I18N"
                                valueText={detallePrestamo?.totalAmount ?? 0}
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 4}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.capitalOwed"
                                titleTextType="I18N"
                                valueText={detallePrestamo?.pendingBalance ?? 0}
                                valueTextType="ARS"
                            />
                        </GridTable.Data>

                        <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 5}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.interests"
                                titleTextType="I18N"
                                valueText={
                                    cancelacionPreview?.payments
                                        ? sumAllValues(cancelacionPreview?.payments, "interestPaid")
                                        : 0
                                }
                                valueTextType="ARS"
                            />
                        </GridTable.Data>

                        <GridTable.Data columnStart={1} columnWidth={isDesktop && 3} rowStart={isDesktop ? 3 : 6}>
                            <hr className="dotted" />
                        </GridTable.Data>

                        <GridTable.Data columnStart={1} rowStart={isDesktop ? 4 : 7}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.earlyCancellationFee"
                                titleTextType="I18N"
                                valueText={cancelacionPreview?.charges?.find((x) => x.code === "COMISION")?.value ?? 0}
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 4 : 8}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.vatCommission"
                                titleTextType="I18N"
                                valueText={
                                    cancelacionPreview?.charges
                                        ? sumAllTypeValues(cancelacionPreview?.charges, "code", "IVA")
                                        : 0
                                }
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 4 : 9}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.vatPerception"
                                titleTextType="I18N"
                                valueText={
                                    cancelacionPreview?.charges
                                        ? sumAllTypeValues(cancelacionPreview?.charges, "code", "PERCEP_IVA")
                                        : 0
                                }
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 10}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.stamped"
                                titleTextType="I18N"
                                valueText={
                                    cancelacionPreview?.charges
                                        ? sumAllTypeValues(cancelacionPreview?.charges, "code", "SELLADOS")
                                        : 0
                                }
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 5 : 11}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.iibb"
                                titleTextType="I18N"
                                valueText={
                                    cancelacionPreview?.charges
                                        ? sumAllTypeValues(cancelacionPreview?.charges, "code", "IIBB")
                                        : 0
                                }
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 3 : 1}
                            rowStart={isDesktop ? 5 : 12}
                            styles={cancelButton && CancelButtonStyles}>
                            <CustomData
                                titleText="loans.anticipatedCancelation.amountToCancel"
                                titleTextType="I18N"
                                valueText={
                                    cancelacionPreview?.totalToCancel +
                                        cancelacionPreview?.chargesToCancel -
                                        cancelacionPreview?.bonification ?? 0
                                }
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
                {!cancelButton ? (
                    <Row style={{ textAlign: "center" }}>
                        <Col lg={4} />
                        <Col lg={4}>
                            <Button
                                bsStyle="primary"
                                defaultLabelText="Cancelar préstamo"
                                loading={false}
                                onClick={() => setcancelButton(!cancelButton)}
                                id="submit-button"
                            />
                        </Col>
                        <Col lg={4} />
                    </Row>
                ) : (
                    cuentaAcreditacion()
                )}
            </>
        );
    };
    const renderBody = () => {
        const prestamoActual = loansList.find((x) => x.number === params.id);
        if (prestamoActual === undefined || prestamoActual === null || !detallePrestamo) {
            return null;
        }
        return (
            <>
                <CustomProductHead backLinkTo={`/loans/detallePrestamo/${params.id}`} className="new-account">
                    <div className="toolbar-item view-title">
                        <ViewTitle id="menu.loans.details.title" defaultValue="Cancelación anticipada" />
                    </div>
                    <Col lg={3} />
                    <Col lg={4} />
                </CustomProductHead>
                <div className="above-the-fold">{renderViewMore()}</div>
            </>
        );
    };

    return (
        <>
            <Notification scopeToShow="loans" />
            <MainContainer showLoader={fetching} className="desktop">
                {renderBody()}
            </MainContainer>
        </>
    );
};

CancelacionAnticipada.propTypes = {
    rest: shape().isRequired,
    detallePrestamo: shape({}).isRequired,
    cancelacionPreview: shape({}).isRequired,
    fetchingAccounts: bool.isRequired,
    fetchingCancelation: bool.isRequired,
    loansList: oneOfType([array]).isRequired,
    isDesktop: oneOfType([string, bool]),
    isMobile: oneOfType([string, bool]),
    fetching: oneOfType([string, bool]),
    accounts: arrayOf(shape({})).isRequired,
    deviceStatus: string.isRequired,
    tokenInfo: shape({}).isRequired,
};

CancelacionAnticipada.defaultProps = {
    isDesktop: false,
    isMobile: false,
    fetching: false,
};

const mapStateToProps = (state) => ({
    fetching: loansSelectors.getFetching(state),
    loansList: loansSelectors.getLoansV2(state),
    cancelacionPreview: loansSelectors.getCancelacionPreview(state),
    fetchingAccounts: bool.isRequired,
    detallePrestamo: loansSelectors.getDetallePrestamo(state),
    accounts: accountsSelectors.getAccounts(state),
    fetchingCancelation: loansSelectors.getFetchingCancelation(state),
    tokenInfo: selectors.getTokenInfo(state),
    deviceStatus: selectors.getDeviceStatus(state),
});

export default connect(mapStateToProps)(CancelacionAnticipada);
